import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { memo, useCallback, useEffect, useRef } from 'react';

import {getIsZendeskFixedButtonVisible, getZendeskSnippetKey} from './zendesk-selectors';
import {useInitZendeskScript, usePrefillEmail} from './zendesk-hooks';
import { ZendeskButton } from './components/ZendeskButton';
import { ZENDESK_BUTTON_TYPES } from './components/ZendeskButtonConstants';
import { ZendeskContext } from './zendeskContext';
import { getUserEmailSelector } from "../../app/appSelectors";
import { useLocation } from "react-router";
import { appHistoryPushWithSearchParams } from "../../app/appHistory";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";

export const Zendesk = memo(({ children, isFixedButtonVisible, userEmail, zendeskSnippetKey }) => {
    const { isWebWidgetInited, setOnWidgetCloseCallback } = useInitZendeskScript(zendeskSnippetKey);
    const location = useLocation();
    const widgetOpenPrev = useRef(null);
    const {locale} = useLangContext();

    usePrefillEmail(isWebWidgetInited, userEmail);

    useEffect(() => {
        if (!isWebWidgetInited || !window.zE) {return;}

        const searchParams = new URLSearchParams(location.search);
        const widgetOpen = !!searchParams.get('support-widget');
        if (widgetOpenPrev.current === widgetOpen) {return;}

        if (widgetOpen) {
            window.zE('webWidget', 'show');
            window.zE('webWidget', 'open');
        } else {
            window.zE('webWidget', 'close');
        }
        widgetOpenPrev.current = widgetOpen;
    }, [isWebWidgetInited, location]);

    useEffect(() => {
        if (!isWebWidgetInited || !window.zE) {return;}
        if (locale) {
            window.zE('webWidget', 'setLocale', locale);
        }
    }, [isWebWidgetInited, locale]);

    const openWebWidget = useCallback(() => {
        appHistoryPushWithSearchParams({'support-widget': '1'})
    },[]);

    return <ZendeskContext.Provider value={{ isWebWidgetInited, openWebWidget, setOnWidgetCloseCallback }}>
        {children}
        {isFixedButtonVisible && <ZendeskButton type={ZENDESK_BUTTON_TYPES.fixed}/>}
    </ZendeskContext.Provider>
});

const mapStateToProps = createStructuredSelector({
    isFixedButtonVisible: getIsZendeskFixedButtonVisible,
    userEmail: getUserEmailSelector,
    zendeskSnippetKey: getZendeskSnippetKey,
});

export default connect(mapStateToProps)(Zendesk);